/**
 * Client-side CSV download of what a card is already showing.
 *
 * Deliberately exports the ROWS THE READER CAN SEE (the fetched page, with the
 * active filters applied) rather than re-querying for everything -- an export
 * that silently ignores the filters on screen would be one more number that
 * does not match what the reader is looking at. The filename carries a date so
 * two exports do not shadow each other in a downloads folder.
 *
 * Values are stringified with full quoting (quotes doubled, so commas and
 * newlines in feedback text survive), and the file leads with a UTF-8 BOM so
 * Excel opens accents correctly. Objects/arrays (e.g. metadata) are skipped by
 * the default column derivation and JSON-encoded if explicitly requested.
 */
export function exportCsv(baseName, rows, columns) {
  if (!rows || rows.length === 0) return;
  const cols = columns
    || Object.keys(rows[0]).filter((k) => typeof rows[0][k] !== 'object' || rows[0][k] === null);
  const cell = (v) => {
    if (v === null || v === undefined) return '';
    const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
    return `"${s.replace(/"/g, '""')}"`;
  };
  const lines = [cols.map(cell).join(',')]
    .concat(rows.map((r) => cols.map((c) => cell(r[c])).join(',')));
  const date = new Date().toISOString().split('T')[0];
  const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${baseName}-${date}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
